import { createSelector } from "@reduxjs/toolkit";
import { NavigatorButtomMenu, Routes } from "const";
import { DisclaimerSelector, RouterSelector } from ".";
import { CustomerSelector } from "./customer-selector";
import navigation from "../reducers/navigation";
import { PortfolioSelector } from "./portfolio-selector";

const disallowPathname = [
  Routes.Disclaimer,
  Routes.Register.CustomerInfo,
  Routes.Register.Suitability, // temporary
  Routes.Register.RiskResult,
  Routes.UltraHigh.PrivateWealthManagement.RegisterForm,
  Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer1,
  Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer2,
  // Routes.UltraHigh.Lounge,
  new RegExp('/ultra-high/portfolio/fund/[^/]+/.+'),
  // (pathname) => pathname.startsWith("/primary"),
];

export const NavigationBottomSelector = {
  state: (state) => state[navigation.name],
  navigationMenuSet: createSelector(
    [
      RouterSelector.location,
      CustomerSelector.isPwmUser,
      PortfolioSelector.isRmUser,
      DisclaimerSelector.accepted,
      DisclaimerSelector.investorPropertiesValid,
    ],
    (location, isPwmUser, isRmUser, acceptedDisclaimer, investorPropertiesValid) => {
      let menuSet = null;
      if (
        acceptedDisclaimer &&
        investorPropertiesValid &&
        !isRmUser &&
        !disallowPathnameForNavigation(location.pathname)
      ) {
        menuSet = isPwmUser
          ? NavigatorButtomMenu.PWM
          : NavigatorButtomMenu.Retail_And_Ultrahigh;
      }
      return menuSet;
    }
  ),
};

const disallowPathnameForNavigation = (pathname) => {
  return disallowPathname.some((pathChecker) => {
    if (pathChecker instanceof RegExp) return pathChecker.test(pathname);
    if (typeof pathChecker === "function") return pathChecker(pathname);
    return pathname.includes(pathChecker);
  });
};
